import { render, staticRenderFns } from "./OperateIdentityDialog.vue?vue&type=template&id=0905ab2a&scoped=true"
import script from "./OperateIdentityDialog.vue?vue&type=script&lang=js"
export * from "./OperateIdentityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905ab2a",
  null
  
)

export default component.exports